import PropTypes from "prop-types";

import ClassroomSwitchSyncModal from "./ClassroomSwitchSyncModal";

const propTypes = {
  modalProps: PropTypes.shape({
    isActive: PropTypes.bool,
  }).isRequired,
};

const ClassroomSwitchSyncModalIndex = (props) => {
  const { isActive } = props.modalProps;
  if (isActive) return <ClassroomSwitchSyncModal {...props} />;
};

ClassroomSwitchSyncModalIndex.propTypes = propTypes;

export default ClassroomSwitchSyncModalIndex;
